import { Caption } from '@vrzl/ui';
import { useEffect, useRef } from 'react';

import type { ChatEntry } from '../api/types';
import { useTypewriter } from '../hooks/useTypewriter';

import { ChatMessage } from './chatMessage';

type ChatMessageListProps = {
  entries: ChatEntry[];
  isPending: boolean;
  documents: { id: string; name: string; sourceFileName: string | null }[];
  eventId: string;
  typingId: string | null;
  onTypingComplete: () => void;
};

export function ChatMessageList({
  entries,
  isPending,
  documents,
  eventId,
  typingId,
  onTypingComplete,
}: ChatMessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  const typingEntry = entries.find((entry) => entry.id === typingId) ?? null;
  const typedContent = useTypewriter(typingEntry?.content ?? '', typingId !== null, onTypingComplete);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [entries, isPending, typedContent]);

  return (
    <div className="flex h-[420px] flex-col gap-4 overflow-y-auto rounded-lg border border-border p-4">
      {entries.map((entry) => {
        const isTyping = entry.id === typingId;
        const renderedEntry = isTyping ? { ...entry, content: typedContent } : entry;

        return (
          <ChatMessage
            key={entry.id}
            entry={renderedEntry}
            documents={documents}
            eventId={eventId}
            hideSources={isTyping}
          />
        );
      })}
      {isPending && <Caption className="italic">De assistent is aan het denken…</Caption>}
      <div ref={bottomRef} />
    </div>
  );
}
